import { generateHTML, useEditor } from "@tiptap/react";
import type { AnyExtension, Editor } from "@tiptap/core";

import { ExtensionKit } from "../extensions/extension-kit";
import { getTableOfContents } from "../extensions/TableOfContents";
import { toast } from "react-toastify";

declare global {
  interface Window {
    editor: Editor | null;
  }
}

export const useBlockEditor = ({ onChange, content, setTableOfContent }) => {
  const editor = useEditor(
    {
      immediatelyRender: true,
      shouldRerenderOnTransaction: false,
      autofocus: true,
      onCreate: (ctx) => {
        if (ctx.editor.isEmpty) {
          ctx.editor.commands.setContent(content);
          ctx.editor.commands.focus("start", { scrollIntoView: true });
        }
      },
      extensions: [...ExtensionKit()].filter(
        (e): e is AnyExtension => e !== undefined
      ),
      editorProps: {
        attributes: {
          autocomplete: "off",
          autocorrect: "off",
          autocapitalize: "off",
          class: "min-h-full",
        },
      },
      onUpdate: ({ editor }) => {
        if (!editor.isEmpty) {
          const newContent = editor.getHTML();
          if (newContent !== content) {
            onChange(newContent);
          }
        } else onChange("");
      },
      onBlur: ({ editor }) => {
        try {
          if (!editor.isEmpty) {
            onChange(editor.getHTML());
            const tocList = getTableOfContents(editor);
            if (!!Object.keys(tocList).length) {
              const html = generateHTML(
                {
                  type: "doc",
                  content: [tocList],
                },

                [...ExtensionKit()].filter(
                  (e): e is AnyExtension => e !== undefined
                )
              );
              setTableOfContent && setTableOfContent(html);
            }
          } else {
            onChange("");
            setTableOfContent && setTableOfContent("");
          }
        } catch (err) {
          if (err instanceof Error) toast.error(err.message);
        }
      },
    },
    []
  );
  window.editor = editor;

  return { editor };
};
